import styled from 'styled-components';

import { basicBodyTextStyle, fonts } from '@dreryk/react-components';

export const StyledPatientCell = styled.div`
   display: flex;
   flex-direction: column;
   gap: 4px;
`;

StyledPatientCell.displayName = 'StyledPatientCell';

export const StyledPatientName = styled.div`
   ${basicBodyTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;

StyledPatientName.displayName = 'StyledPatientName';
